import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/views/Index/index";
// 二级搜索
import Search from "@/components/views/Search/index";
import searchDetail from "@/components/views/Search/searchDetail";
// 组织结构
import Organization from "@/components/views/Organization/index";
import centerIntro from "@/components/views/Organization/Children/centerIntro";
import centerLeader from "@/components/views/Organization/Children/centerLeader";
import centerCate from "@/components/views/Organization/Children/centerCate";
import duty from "@/components/views/Organization/Children/duty";
import organMap from "@/components/views/Organization/Children/organMap";
// 科研与国际合作
import Cooperation from "@/components/views/Cooperation/index";
import CooperMajor from "@/components/views/Cooperation/Children/major";
import CooperDetail from "@/components/views/Cooperation/Children/detail";
import interCooper from "@/components/views/Cooperation/Children/interCooper";
import manageMent from "@/components/views/Cooperation/Children/manageMent";
// 人事
import Personnel from "@/components/views/Personnel/index";
import demeanor from "@/components/views/Personnel/Children/demeanor";
import education from "@/components/views/Personnel/Children/education";
import recruitment from "@/components/views/Personnel/Children/recruitment";
import articleDetails from "@/components/views/Personnel/Children/detail";
import reDetails from "@/components/views/Personnel/Children/reDetail";
import deDetails from "@/components/views/Personnel/Children/deDetail";
// 党建
import BuildingList from "@/components/views/BuildingList/index";
import bdemeanor from "@/components/views/BuildingList/Children/demeanor";
import beducation from "@/components/views/BuildingList/Children/education";
import brecruitment from "@/components/views/BuildingList/Children/recruitment";
import barticleDetails from "@/components/views/BuildingList/Children/detail";
import breDetails from "@/components/views/BuildingList/Children/reDetail";
import bdeDetails from "@/components/views/BuildingList/Children/deDetail";
// 期刊
import Journal from "@/components/views/Journal/index";
import JournalList from "@/components/views/Journal/list";
import JournalDetail from "@/components/views/Journal/detail";
//业务工作
import Business from "@/components/views/BusinessWork/index";
import BusinessIntro from "@/components/views/BusinessWork/Children/introduction";
import BusinessDetail from "@/components/views/businessWork/Children/detail";
import Redirect from "@/components/views/businessWork/Children/redirect";
// 部门新闻和中心xinwen
import News from "@/components/views/News/index";
import NewsList from "@/components/views/News/list";
import NewsDetail from "@/components/views/News/detail";
// 党风建设
import comParty from "@/components/views/ComParty/index";
import comPartyList from "@/components/views/ComParty/list";
import comPartyDetail from "@/components/views/ComParty/detail";
// 重要公告
import announce from "@/components/views/Announce/index";
import announceList from "@/components/views/Announce/list";
import announceDetail from "@/components/views/Announce/detail";
import contractUs from "@/components/views/conUs/contract";
import stateMent from "@/components/views/conUs/statement";
import supervise from "@/components/views/conUs/supervise";
import multipleinfo from "@/components/views/conUs/multipleinfo";
import partyBuilding from "@/components/views/PartyBuilding/partyBuilding";
import linkPage from "@/components/views/LinkPage/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        header: true, //为true的时候   不加载公共的头部
        title: "国家海洋标准计量中心"
      }
    },
    {
      path: "/partyBuilding",
      name: "partyBuilding",
      component: partyBuilding,
      meta: {
        header: true, //为true的时候   不加载公共的头部
        title: "党建专题"
      }
    },
    {
      path: "/redirect",
      name: "Redirect",
      component: Redirect
    },
    {
      path: "/search",
      name: "Search",
      component: Search
    },
    {
      path: "/searchDetail",
      name: "searchDetail",
      component: searchDetail
    },
    {
      path: "/org",
      // name: 'Organization',
      component: Organization,
      children: [
        {
          path: "",
          redirect: "intro"
        },
        {
          path: "intro",
          name: "centerIntro",
          component: centerIntro,
          meta: {
            name: "centerIntro",
            title: "中心概况"
          }
        },
        {
          path: "cate",
          name: "centerCate",
          component: centerCate,
          meta: {
            name: "centerCate",
            title: "中心概况"
          }
        },
        {
          path: "map",
          name: "centerMap",
          component: organMap,
          meta: {
            name: "centerMap",
            title: "中心概况"
          }
        },
        {
          path: "leader",
          name: "centerLeader",
          component: centerLeader,
          meta: {
            name: "centerLeader",
            title: "组织机构"
          }
        },
        {
          path: "duty",
          name: "centerDuty",
          component: duty,
          meta: {
            name: "centerDuty",
            title: "组织机构"
          }
        }
      ]
    },
    {
      path: "/cooperation",
      component: Cooperation,
      children: [
        {
          path: "",
          redirect: "major"
        },
        {
          path: "major",
          name: "CooperMajor",
          component: CooperMajor,
          meta: {
            name: "CooperMajor",
            title: "国际合作"
          }
        },
        {
          path: "detail",
          name: "CooperDetail",
          component: CooperDetail,
          meta: {
            name: "CooperDetail",
            title: "国际合作"
          }
        },
        {
          path: "inter",
          name: "interCooper",
          component: interCooper,
          meta: {
            name: "interCooper",
            title: "国际合作"
          }
        },
        {
          path: "manage",
          name: "manageMent",
          component: manageMent,
          meta: {
            name: "manageMent",
            title: "国际合作"
          }
        }
      ]
    },
    {
      path: "/person",
      component: Personnel,
      children: [
        {
          path: "",
          redirect: "education"
        },
        {
          path: "demeanor",
          name: "demeanor",
          component: demeanor,
          meta: {
            name: "demeanor",
            title: "人才队伍"
          }
        },
        {
          path: "education",
          name: "education",
          component: education,
          meta: {
            name: "education",
            title: "人才队伍"
          }
        },
        {
          path: "recruitment",
          name: "recruitment",
          component: recruitment,
          meta: {
            name: "recruitment",
            title: "人才队伍"
          }
        },
        {
          path: "articleDetails",
          name: "articleDetails",
          component: articleDetails,
          meta: {
            name: "education",
            title: "人才队伍"
          }
        },
        {
          path: "deDetails",
          name: "deDetails",
          component: deDetails,
          meta: {
            name: "demeanor",
            title: "人才队伍"
          }
        },
        {
          path: "reDetails",
          name: "reDetails",
          component: reDetails,
          meta: {
            name: "recruitment",
            title: "人才队伍"
          }
        }
      ]
    },
    {
      path: "/BuildingList",
      name: "BuildingList",
      component: BuildingList,
      children: [
        {
          path: "",
          redirect: "beducation"
        },
        {
          path: "bdemeanor",
          name: "bdemeanor",
          component: bdemeanor,
          meta: {
            name: "bdemeanor",
            title: "党建专题"
          }
        },
        {
          path: "beducation",
          name: "beducation",
          component: beducation,
          meta: {
            name: "beducation",
            title: "党建专题"
          }
        },
        {
          path: "brecruitment",
          name: "brecruitment",
          component: brecruitment,
          meta: {
            name: "brecruitment",
            title: "党建专题"
          }
        },
        {
          path: "barticleDetails",
          name: "barticleDetails",
          component: barticleDetails,
          meta: {
            name: "beducation",
            title: "党建专题"
          }
        },
        {
          path: "bdeDetails",
          name: "bdeDetails",
          component: bdeDetails,
          meta: {
            name: "bdemeanor",
            title: "党建专题"
          }
        },
        {
          path: "breDetails",
          name: "breDetails",
          component: breDetails,
          meta: {
            name: "brecruitment",
            title: "党建专题"
          }
        }
      ]
    },
    {
      path: "/journal",
      component: Journal,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "JournalList",
          component: JournalList,
          meta: {
            name: "JournalList",
            title: "期刊"
          }
        },
        {
          path: "detail",
          name: "JournalDetail",
          component: JournalDetail,
          meta: {
            name: "JournalDetail",
            title: "期刊"
          }
        }
      ]
    },
    {
      path: "/businesss",
      component: Business,
      children: [
        {
          path: "",
          redirect: "intro"
        },
        {
          path: "intro",
          name: "BusinessIntro",
          component: BusinessIntro,
          meta: {
            name: "BusinessIntro",
            title: "业务工作"
          }
        },
        {
          path: "detail",
          name: "BusinessDetail",
          component: BusinessDetail,
          meta: {
            name: "BusinessDetail",
            title: "业务工作"
          }
        }
      ]
    },
    {
      path: "/news",
      component: News,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "NewsList",
          component: NewsList,
          meta: {
            name: "NewsList",
            title: "新闻"
          }
        },
        {
          path: "detail",
          name: "NewsDetail",
          component: NewsDetail,
          meta: {
            name: "NewsDetail",
            title: "新闻"
          }
        }
      ]
    },
    {
      path: "/com-party",
      component: comParty,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "comPartyList",
          component: comPartyList,
          meta: {
            name: "comPartyList",
            title: "党建"
          }
        },
        {
          path: "detail",
          name: "comPartyDetail",
          component: comPartyDetail,
          meta: {
            name: "comPartyDetail",
            title: "党建"
          }
        }
      ]
    },
    {
      path: "/announce",
      component: announce,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "announceList",
          component: announceList,
          meta: {
            name: "announceList",
            title: "公告"
          }
        },
        {
          path: "detail",
          name: "announceDetail",
          component: announceDetail,
          meta: {
            name: "announceDetail",
            title: "公告"
          }
        }
      ]
    },
    {
      path: "/conus",
      component: contractUs,
      name: "contractUs"
    },
    {
      path: "/statement",
      component: stateMent,
      name: "statement"
    },
    {
      path: "/supervise",
      component: supervise,
      name: "supervise"
    },
    {
      path: "/linkPage",
      component: linkPage,
      name: "linkPage",
      meta: {
        header: true, //为true的时候   不加载公共的头部
        title: "国家海洋标准计量中心"
      }
    },
    // 多页面
    {
      path: "/multipleinfo",
      component: multipleinfo,
      name: "multipleinfo"
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
router.beforeEach((to, from, next) => {
  // if(window._hmt){
  //   if(to.path) {
  //     window._hmt.push(['_trackPageview','/#' + to.fullPath])
  //   }
  // }
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = "http://web.ncosm.org.cn/#/";
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js